import { alertActions } from "../../alert.action";
import { systemLabelConstants } from "../../../../constants/system/systemLabels/systemLabels.constants";
import { systemLabelService } from "../../../../services/system/systemLabel/systemLabel.service";
import { requestHandler } from "../../../../helpers/requestHandler";

export const systemLabelActions = {
  getAllGroups,
  getGroup,
  get,
  create,
  update,
  updateRange
};
const currentLoadingGroups = {};
var groupLoading = false;
function getAllGroups() {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    if (!groupLoading) {
      groupLoading = true;
      systemLabelService.getAllGroups().then(
        groups => {
          dispatch(success(groups));
          groupLoading = false;
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
    }
  };

  function request() {
    return { type: systemLabelConstants.GET_ALL_SYSTEM_LABEL_GROUP_REQUEST };
  }
  function success(groups) {
    return {
      type: systemLabelConstants.GET_ALL_SYSTEM_LABEL_GROUP_SUCCESS,
      groups
    };
  }
  function failure(error) {
    return {
      type: systemLabelConstants.GET_ALL_SYSTEM_LABEL_GROUP_FAILURE,
      error
    };
  }
}

function getGroup(languageCode, groupName) {
  return dispatch => {
    if (groupName && !currentLoadingGroups[groupName]) {
      currentLoadingGroups[groupName] = true;
      dispatch(request());
      dispatch(alertActions.clear());
      systemLabelService.getGroup(languageCode, groupName).then(
        (group) => {
          dispatch(success(group, groupName));
          currentLoadingGroups[groupName] = false;
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
          currentLoadingGroups[groupName] = false;
        }
      );
    }
  };

  function request() {
    if (groupName === "Core.Layout")
      return { type: systemLabelConstants.GET_LAYOUT_LABEL_GROUP_REQUEST };
    else return { type: systemLabelConstants.GET_SYSTEM_LABEL_GROUP_REQUEST };
  }
  function success(group, groupName) {
    if (groupName === "Core.Layout")
      return {
        type: systemLabelConstants.GET_LAYOUT_LABEL_GROUP_SUCCESS,
        group,
        groupName
      };
    else
      return {
        type: systemLabelConstants.GET_SYSTEM_LABEL_GROUP_SUCCESS,
        group,
        groupName
      };
  }
  function failure(error) {
    if (groupName === "Core.Layout")
      return {
        type: systemLabelConstants.GET_LAYOUT_LABEL_GROUP_FAILURE,
        error
      };
    else
      return {
        type: systemLabelConstants.GET_SYSTEM_LABEL_GROUP_FAILURE,
        error
      };
  }
}

function get(name, languageCode, groupName) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    systemLabelService.get(name, languageCode, groupName).then(
      label => {
        dispatch(success(label));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: systemLabelConstants.GET_SYSTEM_LABEL_REQUEST };
  }
  function success(label) {
    return { type: systemLabelConstants.GET_SYSTEM_LABEL_SUCCESS, label };
  }
  function failure(error) {
    return { type: systemLabelConstants.GET_SYSTEM_LABEL_FAILURE, error };
  }
}

function create(name, languageCode, groupName) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    systemLabelService.create(name, languageCode, groupName).then(
      labelGroup => {
        dispatch(success(labelGroup, groupName));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    if (groupName === "Core.Layout")
      return { type: systemLabelConstants.CREATE_LAYOUT_LABEL_REQUEST };
    else return { type: systemLabelConstants.CREATE_SYSTEM_LABEL_REQUEST };
  }
  function success(labelGroup, groupName) {
    if (groupName === "Core.Layout")
      return {
        type: systemLabelConstants.CREATE_LAYOUT_LABEL_SUCCESS,
        group: labelGroup,
        groupName
      };
    else
      return {
        type: systemLabelConstants.CREATE_SYSTEM_LABEL_SUCCESS,
        group: labelGroup,
        groupName
      };
  }
  function failure(error) {
    if (groupName === "Core.Layout")
      return { type: systemLabelConstants.CREATE_LAYOUT_LABEL_FAILURE, error };
    else
      return { type: systemLabelConstants.CREATE_SYSTEM_LABEL_FAILURE, error };
  }
}

function update(id, value, hint, languageCode, groupName) {
  /*    requestHandler.setRequestTimer(() => { */
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());

    systemLabelService.update(id, value, hint, languageCode, groupName).then(
      _ => {
        dispatch(success(true));
        dispatch(getGroup(languageCode, groupName));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  /*     }, 5000); */

  function request() {
    return { type: systemLabelConstants.UPDATE_SYSTEM_LABEL_REQUEST };
  }
  function success(status) {
    return { type: systemLabelConstants.UPDATE_SYSTEM_LABEL_SUCCESS, status };
  }
  function failure(error) {
    return { type: systemLabelConstants.UPDATE_SYSTEM_LABEL_FAILURE, error };
  }
}

function updateRange(labelArray) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());

    systemLabelService.updateRange(labelArray).then(
      _ => {
        dispatch(success(true));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: systemLabelConstants.UPDATE_RANGE_SYSTEM_LABEL_REQUEST };
  }
  function success(status) {
    return {
      type: systemLabelConstants.UPDATE_RANGE_SYSTEM_LABEL_SUCCESS,
      status
    };
  }
  function failure(error) {
    return {
      type: systemLabelConstants.UPDATE_RANGE_SYSTEM_LABEL_FAILURE,
      error
    };
  }
}
